exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\t\r\n\t.panel-primary>.panel-heading\r\n\t{\r\n\t\tbackground:#bce8f1;\r\n\t\t\r\n\t}\r\n\t.panel-primary>.panel-body\r\n\t{\r\n\t\tbackground-color: #EDEDED;\r\n\t}*/\r\n.panel-primary\r\n\t{\r\n\r\n          padding-top:50px;\r\n\t}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/USer/Interviewfeedback/src/app/newinterviewreview/newinterviewreview.component.css
// module id = ../../../../../src/app/newinterviewreview/newinterviewreview.component.css
// module chunks = main